module.exports = __webpack_public_path__ + "media/images/fit_4-9034b78e7bb0c648a360e4781ad5faa6.png";